var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ops-page" }, [
    _c(
      "div",
      { staticClass: "ops-tabs" },
      [
        _c(
          "el-radio-group",
          {
            staticClass: "ops-radio-group",
            attrs: { size: "medium" },
            model: {
              value: _vm.activeKey,
              callback: function ($$v) {
                _vm.activeKey = $$v
              },
              expression: "activeKey",
            },
          },
          _vm._l(_vm.tabs, function (tab) {
            return _c(
              "el-radio-button",
              { key: tab.key, attrs: { label: tab.key } },
              [_vm._v("\n        " + _vm._s(tab.label) + "\n      ")]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ops-content" },
      [_c(_vm.currentComponent, { tag: "component" })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }